export default __webpack_public_path__ + "static/media/fa-regular-400.4079ae2d.eot";